import { PopoverProps } from "@mui/material";
import { usePopoverSelectors } from "../../../../app/state/popoverSlice/hook/use-popover-selectors";
import { TPopoverIds } from "../../../../app/state/popoverSlice/types";
import { AppPopover } from "../../../AppPopover";
import { PopoverBasic } from "../../../Components/Popovers/PopoverBasic";
import styles from "./styles.module.css";

interface Props extends Omit<PopoverProps, "open"> {
  children: React.ReactNode;
  closePopover: (id: TPopoverIds) => void;
  className?: string;
}

export const SidebarSearchPopover = ({
  children,
  closePopover,
  className,
}: Props) => {
  const searchPopover = usePopoverSelectors("sidebar_search_popover");
  const safeX = searchPopover.position?.x ?? 0;
  const safeY = searchPopover.position?.y ?? 0;
  return (
    <AppPopover
      open={searchPopover.isOpen}
      onClose={() => closePopover("sidebar_search_popover")}
      anchorReference={"anchorPosition"}
      anchorPosition={{
        left: safeX + 35,
        top: safeY + 35,
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      classes={{
        paper: styles.root,
      }}
    >
      <div className={styles["body"]}>{children}</div>
    </AppPopover>
  );
};
